import gql from 'graphql-tag';

const ANSWER_IMPORTANCE = gql`
mutation answerImportance($tester:ID!, $question:ID!, $answer: [ID!]!){
    answerImportanceQuestion(participantId: $tester, campaignQuestionId: $question, answer: $answer)
}
`;

export default ANSWER_IMPORTANCE;